import React from "react";

export default function IncreaseVector({ color }) {
  return (
    <>
      <svg
        width="154"
        height="56"
        viewBox="0 0 154 56"
        fill="none"
        color={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.937 14.613C19.9729 12.8869 6.58463 21.1512 0.135986 25.4991V56H153.332V0C145.803 5.72095 130.078 17.1629 127.407 17.1629C124.068 17.1629 119.845 6.66899 115.622 5.00174C111.4 3.33449 108.945 22.1646 105.213 22.1646C101.481 22.1646 90.5806 18.4378 85.4741 17.1629C80.3676 15.8879 73.3952 20.8897 67.8958 22.1646C62.3965 23.4396 60.0396 14.613 55.8169 14.613C51.5942 14.613 38.2386 25.4991 34.0159 25.4991C29.7932 25.4991 24.392 16.7706 21.937 14.613Z"
          fill="url(#paint0_linear_417_3044)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_417_3044"
            x1="77"
            y1="-68.5"
            x2="77"
            y2="46"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2FCA8C" stopOpacity="0" />
            <stop offset="1" stopColor="currentColor" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}
